// src/pages/ZusammenfassungProtokoll.jsx

import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Box, Heading, Text, VStack, Image } from "@chakra-ui/react";

export default function ZusammenfassungProtokoll() {
    const { id } = useParams();
    const [data, setData] = useState(null);

    useEffect(() => {
        fetch(`${process.env.REACT_APP_API_URL}/api/wartungsprotokoll/${id}`, {
            credentials: "include"
        })
            .then(res => res.json())
            .then(setData);
    }, [id]);

    if (!data) return <Text>Lade Daten…</Text>;

    const verschattungList = data.verschattung
        ? data.verschattung.split(",")
        : [];

    return (
        <Box maxW="4xl" mx="auto" mt={10} p={8} bg="white" borderRadius="xl" boxShadow="lg">
            <Heading size="lg" mb={6}>Zusammenfassung</Heading>

            <VStack align="stretch" spacing={6}>

                {/* --- Bedingungen vor Ort --- */}
                {(data.anlagennummer || data.datum || data.uhrzeitVon || data.uhrzeitBis || data.temperatur) && (
                    <Box>
                        <Heading size="md" mb={2}>Bedingungen vor Ort</Heading>
                        {data.anlagennummer && <Text>Anlagennummer: {data.anlagennummer}</Text>}
                        {data.datum && <Text>Datum: {data.datum}</Text>}
                        {data.uhrzeitVon && <Text>Uhrzeit von: {data.uhrzeitVon}</Text>}
                        {data.uhrzeitBis && <Text>Uhrzeit bis: {data.uhrzeitBis}</Text>}
                        {data.temperatur && <Text>Temperatur: {data.temperatur} °C</Text>}
                    </Box>
                )}

                {/* --- Betriebszustand --- */}
                {data.betriebszustand && (
                    <Box>
                        <Heading size="md" mb={2}>Betriebszustand</Heading>
                        <Text>Zustand: {data.betriebszustand}</Text>
                        {data.teilbetriebWert && <Text>Teilbetrieb: {data.teilbetriebWert}</Text>}
                    </Box>
                )}

                {/* --- Einstrahlungsbedingungen --- */}
                {data.einstrahlung && (
                    <Box>
                        <Heading size="md" mb={2}>Einstrahlungsbedingungen</Heading>
                        <Text>{data.einstrahlung}</Text>
                    </Box>
                )}

                {/* --- Verschattungen --- */}
                {verschattungList.length > 0 && (
                    <Box>
                        <Heading size="md" mb={2}>Verschattungen</Heading>
                        {verschattungList.map((item, index) => (
                            <Text key={index}>• {item}</Text>
                        ))}
                    </Box>
                )}

                {/* --- Bilder anzeigen --- */}
                {data.bilder && data.bilder.length > 0 && (
                    <Box mt={10}>
                        <Heading size="md" mb={3}>Bilder</Heading>

                        <VStack align="stretch" spacing={4}>
                            {data.bilder.map((img, index) => (
                                <Image
                                    key={index}
                                   src={`${process.env.REACT_APP_API_URL}/uploads/${img.filename}`}
                                    alt={`Bild ${index + 1}`}
                                    borderRadius="md"
                                    boxShadow="md"
                                />
                            ))}
                        </VStack>
                    </Box>
                )}

            </VStack>
        </Box>
    );
}